import md from '@/routes/middlewares';

import SiteProduct from '@/views/associatedProducts/SiteProduct.vue';
import SiteDashboard from '@/views/sites/siteDashboard/';
import SiteInfo from '@/views/sites/SiteInfo.vue';
import SitePage from '@/views/sites/SitePage.vue';
import SiteTree from '@/views/sites/SiteTree.vue';
import Procedures from '@/views/sites/procedures/Procedures.vue';
import ExportAnalysisMeasures from '@/views/clients/ExportAnalysisMeasures';
import ClientGraphics from '@/views/clients/ClientGraphics.vue';
import Contact from '@/views/contacts/Contact.vue';
import ContactPage from '@/views/ContactPage.vue';
import Contacts from '@/views/contacts/Contacts.vue';
import AssociatedProducts from '@/views/associatedProducts/AssociatedProducts.vue';
import WorkOrders from '@/views/workOrders/WorkOrders.vue';
import MassBalance from '@/views/MassBalance.vue';
import SiteReports from '@/views/sites/report/SiteReports.vue';
import SiteAlerts from '@/views/sites/alerts/SiteAlertReports.vue';
import SiteLogs from '@/views/sites/logs/SiteLogs.vue';
import Controllers from '@/views/sites/devices/Devices.vue';
import SiteAnalysisRequest from '@/views/sites/labAnalysisRequest/siteAnalysisRequest.vue';

import component from '@/routes/client/site/component';
import network from '@/routes/client/site/network/network';
import document from '@/routes/client/site/document';
import workorder from '@/routes/client/site/workOrder';
import WorkOrdersTemplate from '@/views/workOrders/template/WorkOrdersTemplate.vue';
import SectionTemplate from '@/views/workOrders/template/SectionTemplate.vue';
import AppointmentPage from '@/views/calendar/AppointmentPage.vue';
import Cart from '@/views/cart/Cart.vue';

const site = {
    path: 'sites/:siteId',
    name: 'sitePage',
    redirect: { name: 'siteTree' },
    component: SitePage,
    meta: {
        middlewares: [
            md.getSiteInfo,
            md.isSiteIncludedInClient,
            md.getActiveOrders,
        ],
    },
    children: [
        component,
        network,
        workorder,
        ...document,
        {
            path: 'cart',
            name: 'cart',
            component: Cart,
        },
        {
            path: 'info',
            name: 'siteInfo',
            component: SiteInfo,
        },
        {
            path: 'siteDashboard',
            name: 'siteDashboard',
            component: SiteDashboard,
        },
        {
            path: 'siteTree',
            name: 'siteTree',
            component: SiteTree,
        },
        {
            path: 'massBalance',
            name: 'siteMassBalance',
            component: MassBalance,
        },
        {
            path: 'siteNorms',
            name: 'siteNorms',
        },
        {
            path: 'procedures',
            name: 'siteProcedures',
            component: Procedures,
        },
        {
            path: 'exportAnalysis',
            name: 'exportAnalysis',
            component: ExportAnalysisMeasures,
        },
        {
            path: 'graphics',
            name: 'graphics',
            component: ClientGraphics,
        },
        {
            path: 'workOrdersTemplate',
            name: 'siteWorkOrdersTemplate',
            component: WorkOrdersTemplate,
        },
        {
            path: 'workOrdersTemplate/createTemplate',
            name: 'siteCreateTemplate',
            component: SectionTemplate,
        },
        {
            path: 'workOrdersTemplate/:woTemplateId',
            redirect: { name: 'siteEditTemplate' },
            component: SectionTemplate,
            meta: {
                middlewares: [md.getWOTemplateInfo],
            },
            children: [
                {
                    path: 'editTemplate',
                    name: 'siteEditTemplate',
                },
            ],
        },
        {
            path: 'appointment',
            name: 'siteAppointment',
            component: AppointmentPage,
        },
        // CONTACTS
        {
            path: 'contacts',
            name: 'siteContacts',
            component: Contacts,
        },
        {
            path: 'contacts/:contactId',
            component: ContactPage,
            redirect: { name: 'siteContact' },
            children: [
                {
                    path: 'info',
                    name: 'siteContact',
                    component: Contact,
                },
            ],
        },
        // PRODUCTS
        {
            path: 'products',
            name: 'siteProducts',
            component: AssociatedProducts,
        },
        {
            path: 'products/:productId',
            name: 'siteProduct',
            component: SiteProduct,
            meta: {
                middlewares: [md.getSiteProductInfo],
            },
        },
        // WORK ORDERS
        {
            path: 'workOrders',
            name: 'siteWorkOrders',
            component: WorkOrders,
        },
        // Controllers
        {
            path: 'devices',
            name: 'siteControllers',
            component: Controllers,
        },
        // Analysis Request
        {
            path: 'analysisRequest',
            name: 'siteAnalysisRequest',
            component: SiteAnalysisRequest,
        },
        // Reports
        {
            path: 'reports',
            name: 'siteReports',
            component: SiteReports,
        },
        {
            path: 'alerts',
            name: 'siteAlerts',
            component: SiteAlerts,
        },
        // Logs
        {
            path: 'logs',
            name: 'siteLogs',
            component: SiteLogs,
        },
    ],
};

export default site;
